<template>
	<div>
		<aeg-case-home
			:caseViews="caseViews"
			addProposalButtonText="Add Employees Compensation Proposal"
			productTypeLabel="Type"
			selectProductInsuranceType="employees_compensation"
		></aeg-case-home>
	</div>
</template>

<script>
import AegCaseHome from "./AegCaseHome"

export default {
	components: {
		AegCaseHome
	},
	data() {
		return {
			caseViews: {
				employees_compensation: "AegCaseEmployeesCompensation"
			}
		}
	}
}
</script>
